import {apiUrl} from "./api_url";

export async function stop_api() {
    const token = localStorage.getItem('accessToken');

    if (!token) {
        return {message: "Authorization token required", authorized: false}
    }

    try {
        const response = await fetch(`${apiUrl}/candle-direction/stop`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            }
        });

        const data = await response.json();

        if (response.ok) {
            return data.message
        } else {
            return data.message
        }
    } catch (error) {
        console.error(error);
        throw error;
    }
}
